// DropZone.js
import React from 'react';
import { useDrop } from 'react-dnd';

// Move ItemTypes outside the component
export const ItemTypes = {
  JOB: 'JOB',
  CREW_LIST: 'CREW_LIST',
};

function DropZone({ date, index, moveJob, assignCrewToJob, children, extend }) {
 
  const [{ isOver }, dropRef] = useDrop({
    accept: [ItemTypes.JOB],
    drop: (item) => {
     
      if (item.type === ItemTypes.JOB) {
        const dragDate = item.date;
        const dragIndex = item.index;
        const dropDate = date;
        const dropIndex = index;

        if (dragDate === dropDate && dragIndex === dropIndex) return;

        moveJob(item, dragDate, dragIndex, dropDate, dropIndex);
        
        item.index = dropIndex;
        item.date = dropDate;
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div
      ref={dropRef}
      style={{
        minHeight: extend ? '60px' : '20px',
        margin: '0px 0',
        backgroundColor: isOver ? 'lightblue' : 'transparent',
        transition: 'background-color 0.2s ease',
      }}
    >
      {children}
    </div>
  );
}

// Use React.memo with shallow compare
function areEqual(prev, next) {
  return prev.date === next.date && prev.index === next.index;
}

export default React.memo(DropZone, areEqual);
